import { Injectable } from '@angular/core';
import { StorageKeys } from 'src/cometchat-pro-angular-ui-kit/CometChatWorkspace/projects/angular-chat-ui-kit/src/utils/enums';
import { SearchDTO } from '../_models/searchdto';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    public token: string;
    public user: any;
    public location: SearchDTO;
    public userPosition: SearchDTO;
    constructor() { }

    GetProperty(key) {
        var val = window.localStorage.getItem(key);
        if (val != "undefined") {
            return JSON.parse(val);
        }
        else {
            return val;
        }
    }

    SetProperty(key, value, parse = true) {
        if (parse) {
            window.localStorage.setItem(key, JSON.stringify(value));
        }
        else {
            window.localStorage.setItem(key, value);
        }

    }


    setToken(token: string) {
        this.token = this.GetProperty(StorageKeys.AuthToken);
        if (!this.token) {
            this.token = "";
        }
        this.token = token;
        this.RemoveProperty(StorageKeys.AuthToken);
        this.SetProperty(StorageKeys.AuthToken, this.token);
    }

    getToken() {
        this.token = this.GetProperty(StorageKeys.AuthToken);
        if (!this.token) {
            this.token = "";
        }
        return this.token;
    }

    RemoveProperty(key) {
        window.localStorage.removeItem(key);
        return true;
    }

    RemoveAllProperties() {
        window.localStorage.clear();
        return true;
    }


    setLocation(location: SearchDTO){
        this.location = new SearchDTO();
        this.location = Object.assign(this.location,location);
        this.RemoveProperty (StorageKeys.CurrentLocation);
        this.SetProperty (StorageKeys.CurrentLocation,this.location);
    }

    getLocation():SearchDTO{
        this.location = new SearchDTO();
        this.location = this.GetProperty (StorageKeys.CurrentLocation);
        return this.location;
    }

    setUserLocation(location: SearchDTO){
        this.userPosition = new SearchDTO();
        this.userPosition = Object.assign(this.userPosition,location);
        this.RemoveProperty (StorageKeys.UserPosition);
        this.SetProperty (StorageKeys.UserPosition,this.userPosition);
    }
    getUserPosition(): SearchDTO {
        this.userPosition = new SearchDTO();
        this.userPosition = this.GetProperty(StorageKeys.UserPosition);
        return this.userPosition;
    }

  

}